import { useQuery } from '@tanstack/react-query';

import { fetchLinkedInCredentials } from '../api/credentials';
import type { LinkedInCredential } from '../types';
import { credentialKeys } from './queryKeys';

/**
 * The company's connected LinkedIn accounts.
 *
 * <p>No `enabled` guard — the request takes no argument and the tenant comes from the session
 * — and no `staleTime`: `app/providers/queryClient.ts` sets `staleTime: 0` and `gcTime: 0` for
 * the whole application, and a connection that was just dropped is exactly a change this screen
 * must not paper over. The screen decides what a failure means: the connect screen treats it as
 * "no account to show" and offers the form, as the previous screen did.
 */
export function useLinkedInCredentials() {
  return useQuery<LinkedInCredential[]>({
    queryKey: credentialKeys.list(),
    queryFn: fetchLinkedInCredentials,
  });
}
